import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, OnChanges } from '@angular/core';
import { SceneType } from '@shared/models';

@Component({
    selector: 'type-selector',
    templateUrl: './type-selector.component.html',
    styleUrls: ['./type-selector.component.scss']
})
export class TypeSelectorComponent implements OnInit {
    @Output() add = new EventEmitter<string>();
    @Input() is360Only: boolean;
    typeList: string[];

    ngOnInit(): void {
        this.typeList = Object.values(SceneType);
    }

    getIcon(type: string): string {
        if (type.toLowerCase().indexOf('image') >= 0) {
            return 'image';
        }
        if (type.toLowerCase().indexOf('video') >= 0) {
          return 'movie';
      }
        else {
            return 'question_answer';
        }
    }
    onAdd(type: string): void {
        this.add.emit(type);
    }
}
